import { render, staticRenderFns } from "./AdSlot.vue?vue&type=template&id=081a3ddd&scoped=true&"
import script from "./AdSlot.vue?vue&type=script&lang=js&"
export * from "./AdSlot.vue?vue&type=script&lang=js&"
import style0 from "./AdSlot.vue?vue&type=style&index=0&id=081a3ddd&lang=scss&scoped=true&"
import style1 from "./AdSlot.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081a3ddd",
  null
  
)

/* custom blocks */
import block0 from "./AdSlot.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports